export default {
  getPlaygrounds: (state) => {
    return state.playgrounds;
  },
  getLoader: (state) => {
    return state.loader;
  },
  getSelectedBlockPrices: (state) => {
    return state.selectedBlockPrices;
  },
  getBlockPricesTotalItems: (state) => {
    return state.selectedBlockPrices.length;
  },
  getClubTimetables: (state) => {
    return state.clubTimetables;
  },
  getSelectedTimetables: (state) => {
    return state.selectedTimetables;
  },
  getTimetablesTotalItems: (state) => {
    return state.selectedTimetables.length;
  },
}
